/* eslint-disable import-x/no-default-export */
import { MockList } from '@graphql-tools/mock';
import Chance from 'chance';

const chance = new Chance();

const qualifications = [
  'Bachelor of Commerce',
  'Bachelor of Computing',
  'Bachelor of Science',
  'Certificate I in Work Education',
  'Certificate III in Aged Care',
  'Certificate III in Printing Machining',
  'Diploma of Accounting',
  'Diploma of Legal Practice',
  'Diploma of Quality Auditing',
  'Doctor of Philosophy',
  'Queensland Certificate of Education',
];

export default () => {
  const qualification = chance.pickone(qualifications);

  return {
    id: `http://graph.seek.com/EducationLibrary/${chance.integer({
      min: 0,
      max: 9999,
    })}`,
    matchedVariant: qualification,
    normalisedText: qualification,
    highlights: () => new MockList([0, 1]),
  };
};
